import { Navigate, createRootRouteWithContext } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { RootPage } from '@/pages/RootPage.tsx';
import { DEFAULT_ROUTE } from '@/consts/router.ts';

import '../styles.css';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootPage,
  notFoundComponent: () => <Navigate to={DEFAULT_ROUTE} />,
});
